module.exports = __webpack_public_path__ + "static/media/2XL.bcecd4a4.jpg";